<style lang="less">

.footer_code {
    display: inline-block;
    text-align: center;
    padding: 4.3px 16px;
    box-sizing: border-box;
    img {
        width: 120px;
        height: 120px;
    }
    p {
        margin-top: 4px;
        font-weight: 600;
        color:#000;
    }
}

</style>

<template>
<div class="footer_box">
    <div class="container_box">
        <div class="nav_box">
            <!-- <div class="nav_item media_small_hide" v-for="(item,key) in NavList" :key="key">
                <div class="title"><router-link :to="item.routerPath">{{ item.name }}</router-link></div>
            </div> -->
            <!-- <div class="nav_item media_small_hide">
                <div class="title"><router-link to="">公棚</router-link></div>
                <div class="item"><router-link to="/shed-index">赛事列表</router-link></div>
                <div class="item"><router-link to="/shed-index/match-regulation">赛事规程</router-link></div>
                <div class="item"><router-link to="/shed-index/shed-news"> 最新公告</router-link></div>
                <div class="item"><router-link to="/shed-index/shed-introduce">公棚介绍</router-link></div>
                <div class="item"><router-link to="/breeding-center/honour-halls">荣誉殿堂</router-link></div>
                <div class="item"><router-link to="/breeding-center/breeding-engineering">六信工程</router-link></div>
                <div class="item"><router-link to="/breeding-center/breeding-match1">国内外赛事</router-link></div>
            </div>
            <div class="nav_item media_small_hide">
                <div class="title"><router-link to="">藏鸽展示</router-link></div>
                <div class="item"><router-link to="/breeding-center/pigeon-appreciate">邢小信藏鸽</router-link></div>
            </div>
            <div class="nav_item media_small_hide">
                <div class="title"><router-link to="">关于我们</router-link></div>
                <div class="item"><router-link to="/group-introduce/group-introduce">鸽业介绍</router-link></div>
                <div class="item"><router-link to="/group-introduce/brand-story">品牌故事</router-link></div>
                <div class="item"><router-link to="/group-introduce/group-culture">企业文化</router-link></div>
                <div class="item"><router-link to="/group-introduce/charity-public">慈善公益</router-link></div>
                <div class="item"><router-link to="/group-introduce/honour-halls">荣誉殿堂</router-link></div>
                <div class="item"><router-link to="/breeding-center/breeding-introduce">育种中心介绍</router-link></div>
            </div> -->
            <!-- <div class="nav_item media_small_hide">
                <div class="title"><router-link to="">爱心公棚</router-link></div>
                <div class="item"><router-link to="/shed-index/shed-news">最新动态</router-link></div>
                <div class="item"><router-link to="/shed-index/shed-introduce">公棚介绍</router-link></div>
                <div class="item"><router-link to="/shed-index/shed-engineering">六信工程</router-link></div>
                <div class="item"><router-link to="/shed-index/match-regulation">赛事规程</router-link></div>
                <div class="item"><router-link to="/shed-index/honour-halls">荣誉殿堂</router-link></div>
                <div class="item"><router-link to="/shed-index/match-reserve">比赛预订</router-link></div>
                <div class="item"><router-link to="/shed-index/results-enquiry">成绩查询</router-link></div>
                <div class="item"><router-link to="/shed-index/specify-query">指定查询</router-link></div>
                <div class="item"><router-link to="/shed-index/videos">视频</router-link></div>
                <div class="item"><router-link to="/shed-index/pictures">图片</router-link></div>
                <div class="item"><router-link to="/shed-index/shed-album">公棚相册</router-link></div>
                <div class="item"><router-link to="/shed-index/pigeon-mien">获奖鸽风采</router-link></div>
                <div class="item"><router-link to="/shed-index/charity-public">慈善公益</router-link></div>
                <div class="item"><router-link to="">收鸽动态</router-link></div>
                <div class="item"><router-link to="">在线指定</router-link></div>
            </div>
            <div class="nav_item media_small_hide">
                <div class="title"><router-link to="">青年队</router-link></div>
                <div class="item"><router-link to="/shed-youth/shed-news">最新动态</router-link></div>
                <div class="item"><router-link to="/shed-youth/shed-introduce">公棚介绍</router-link></div>
                <div class="item"><router-link to="/shed-youth/shed-engineering">六信工程</router-link></div>
                <div class="item"><router-link to="/shed-youth/match-regulation">赛事规程</router-link></div>
                <div class="item"><router-link to="/shed-youth/honour-halls">荣誉殿堂</router-link></div>
                <div class="item"><router-link to="/shed-youth/results-enquiry">成绩查询</router-link></div>
                <div class="item"><router-link to="/shed-youth/specify-query">指定查询</router-link></div>
                <div class="item"><router-link to="/shed-youth/videos">视频</router-link></div>
                <div class="item"><router-link to="/shed-youth/pictures">图片</router-link></div>
            </div> -->
            <!-- <div class="nav_item">
                <div class="title"><router-link to="">先锋队</router-link></div>
                <div class="item"><router-link to="/shed-vanguard/shed-news">最新动态</router-link></div>
                <div class="item"><router-link to="/shed-vanguard/shed-introduce">公棚介绍</router-link></div>
                <div class="item"><router-link to="/shed-vanguard/shed-engineering">六信工程</router-link></div>
                <div class="item"><router-link to="/shed-vanguard/match-regulation">赛事规程</router-link></div>
                <div class="item"><router-link to="/shed-vanguard/honour-halls">荣誉殿堂</router-link></div>
                <div class="item"><router-link to="/shed-vanguard/results-enquiry">成绩查询</router-link></div>
                <div class="item"><router-link to="/shed-vanguard/specify-query">指定查询</router-link></div>
                 <div class="item"><router-link to="/shed-vanguard/videos">视频</router-link></div>
                <div class="item"><router-link to="/shed-vanguard/pictures">图片</router-link></div>
            </div> -->
            <!-- <div class="nav_item media_small_hide">
                <div class="title"><router-link to="">春棚</router-link></div>
                <div class="item"><router-link to="/shed-spring/shed-news">最新动态</router-link></div>
                <div class="item"><router-link to="/shed-spring/shed-introduce">公棚介绍</router-link></div>
                <div class="item"><router-link to="/shed-spring/shed-engineering">六信工程</router-link></div>
                <div class="item"><router-link to="/shed-spring/match-regulation">赛事规程</router-link></div>
                <div class="item"><router-link to="/shed-spring/honour-halls">荣誉殿堂</router-link></div>
                <div class="item"><router-link to="/shed-spring/results-enquiry">成绩查询</router-link></div>
                <div class="item"><router-link to="/shed-spring/specify-query">指定查询</router-link></div>
                 <div class="item"><router-link to="/shed-spring/videos">视频</router-link></div>
                <div class="item"><router-link to="/shed-spring/pictures">图片</router-link></div>
            </div> -->
            <!-- <div class="nav_item">
                <div class="title"><router-link to="/performance/race-performance">开尔赛绩</router-link></div>
            </div>
            <div class="nav_item">
                <div class="title"><router-link to="/welfare/public-welfare">公益足迹</router-link></div>
            </div> -->
            <!-- <div class="nav_item">
                <div style="margin-bottom:37px;"></div>
                <div class="item"><router-link to="">结算记录</router-link></div>
                <div class="item"><router-link to="/shed-index/shed-album">公棚相册</router-link></div>
                <div class="item"><router-link to="/shed-index/pigeon-mien">获奖鸽风采</router-link></div>
            </div> -->
            <!-- <div class="nav_item">
                <div class="title"><router-link to="">俱乐部</router-link></div>
                <div class="item"><router-link to="/club-index/club-news">最新动态</router-link></div>
                <div class="item"><router-link to="/club-index/club-introduce">俱乐部介绍</router-link></div>
                <div class="item"><router-link to="/club-index/club-engineering">六信工程</router-link></div>
                <div class="item"><router-link to="/club-index/match-regulation">赛事规程</router-link></div>
                <div class="item"><router-link to="/club-index/honour-halls">荣誉殿堂</router-link></div>
                。<div class="item"><router-link to="/club-index/club-notice">公告</router-link></div>
                。<div class="item"><router-link to="">竞赛规则</router-link></div>
                。<div class="item"><router-link to="">结算记录</router-link></div>
                。<div class="item"><router-link to="/club-index/results-enquiry">成绩查询</router-link></div>
                。<div class="item"><router-link to="/club-index/club-album">俱乐部相册</router-link></div>
                。<div class="item"><router-link to="/club-index/charity-public">慈善公益</router-link></div>
            </div> -->
            <!-- <div class="nav_item">
                <div class="title"><router-link to="">会员中心</router-link></div>
                <div class="item"><router-link to="">我的积分</router-link></div>
                <div class="item"><router-link to="">我的订单</router-link></div>
                <div class="item"><router-link to="/member-index/account-info">账号资料</router-link></div>
                <div class="item"><router-link to="/member-index/my-pigeon">我的赛鸽</router-link></div>
                <div class="item"><router-link to="/member-index/my-events">我的赛事</router-link></div>
                <div class="item"><router-link to="/member-index/deliver-record">交鸽记录</router-link></div>
            </div> -->
            <!-- <div class="nav_item media_small_hide">
                <div class="title"><router-link to="">友情链接</router-link></div>
                <div class="item"><a href="https://kaiergeye.com/" target="_blank">拍卖</a></div>
                <div class="item"><a href="https://kaier.cc/introduction" target="_blank">信鸽云</a></div>
                <div class="item"><a href="https://auctions.pipa.be/zh-hans/?utm_source=kaier" target="_blank">PIPA</a></div>
            </div> -->
            <!-- <div class="nav_item contact_us_box media_small_hide">
                <div style="margin-right: 50px;">
                    <img src="../assets//images/wx-code.png" alt="">
                    <p class="us_box_name">扫一扫关注<br/>开尔鸽业公众号</p>
                </div>
                
                <div>
                    <img src="../assets//images/download-app.png" alt="">
                    <p class="us_box_name">扫一扫下载<br/>邢小信APP</p>
                </div>      
                <div class="map_box">
                    <div class="container_us_box">
                    <div class="form_box">
                        <div class="img_box media_small_hide">
                        <img src="../assets/images/contact-us.png" alt="" />
                        </div>
                        <div class="info_us_box">
                        <div class="title">联系我们</div>
                        <div class="top_input_box">
                            <div class="input_item">
                            <div class="label">姓名</div>
                            <el-input
                                v-model="postData.name"
                                class="value"
                                placeholder=""
                            ></el-input>
                            </div>
                            <div class="input_item">
                            <div class="label">联系电话</div>
                            <el-input
                                v-model="postData.phoneNumber"
                                class="value"
                                placeholder=""
                            ></el-input>
                            </div>
                            <div class="input_item">
                            <div class="label">邮箱</div>
                            <el-input
                                v-model="postData.mail"
                                class="value"
                                placeholder=""
                            ></el-input>
                            </div>
                        </div>
                        <div class="text_box">
                            <el-input
                            v-model="postData.content"
                            placeholder="如果您对我们的产品有订购需求或者建议，欢迎联系我们！开尔竭诚欢迎您！"
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4 }"
                            ></el-input>
                            <div class="btn_box">
                            <div class="submit_btn" @click="getSubmit()">提交</div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div> -->
        </div>

        <div class="info_box">
            <div>
                <div class="logo_box" @click="getIndex()"><img src="../assets/images/index_bot_logo.png" alt=""></div>
                <!-- <div class="info_item">
                    <img src="../assets/images/tel.png" alt="">
                    电话：400 0691 000
                </div> -->
                <!-- <div class="info_item">
                    <img src="../assets/images/address.png" alt="">
                    地址：河北省唐山市高新区高新西道17号
                </div> -->
                <a id="imgurl" href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91130293MAEQGW203A-SAIC_SHOW_10000091130293MAEQGW203A1756978688683&signData=MEUCIB2VPie7BhVOv9SKZeLxOUPu55JDbMZ18FYdbUxfTZ8vAiEAoxNC5BGOv1taNqb79rLKHRAh5su7LC+LMU5WcXxcXlc=" title="电子营业执照" target="_blank">
                    <img src="../assets/images/lz4.png" width="32" border="0">
                </a>

                <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" class="info_item" >
                    备案号：冀ICP备2025123743号
                </a>
            </div>

            <!-- PC端 -->
            <div class="flex_column felx_border media_small_hide">
                <div class="text_h1">联系我们</div>
                <div class="item"><a href="https://kaiergeye.com/" target="_blank">公棚联系方式</a></div>
            </div>

            <div class="flex_column felx_border media_small_hide">
                <div class="text_h1">相关网站</div>
                <div class="item"><a href="https://kaiergeye.com/" target="_blank">拍卖</a></div>
                <div class="item"><a href="https://xgyun.com" target="_blank">信鸽云</a></div>
                <div class="item"><a href="https://auctions.pipa.be/zh-hans/?utm_source=kaier" target="_blank">PIPA</a></div>
            </div>
            
            <div class="flex_column felx_border media_small_hide">
                <div class="text_h1">关注我们</div>
                <div class="nav_item">
                    <div class="item">
                        <el-popover
                            placement="top-start"
                            trigger="hover">
                            <div class="footer_code">
                                <img src="../assets/images/sph_kegy.png" alt="">
                                <p>开尔鸽业</p>
                            </div>
                            <div class="footer_code">
                                <img src="../assets/images/sph_cp.png" alt="">
                                <p>开尔爱心公棚春棚</p>
                            </div>
                            <div class="footer_code">
                                <img src="../assets/images/sph_axgp.png" alt="">
                                <p>开尔爱心公棚大棚</p>
                            </div>
                            <img slot="reference" src="../assets/images/sph.png" alt="">
                        </el-popover>
                    </div>
                    <div class="item">
                        <el-popover
                            placement="top-start"
                            trigger="hover">
                            <img src="../assets/images/wx-code.png" alt="">
                            <img slot="reference" src="../assets/images/wx.png" alt="">
                        </el-popover>
                    </div>
                    <div class="item">
                        <el-popover
                            placement="top-start"
                            trigger="hover">
                            <div class="footer_code">
                                <img src="../assets/images/ks_axgp.png" alt="">
                                <p>开尔爱心公棚</p>
                            </div>
                            <div class="footer_code">
                                <img src="../assets/images/ks_kegy.png" alt="">
                                <p>开尔鸽业</p>
                            </div>
                            <img slot="reference" src="../assets/images/ks.png" alt="">
                        </el-popover>
                    </div>
                    <div class="item">
                        <el-popover
                            placement="top-start"
                            trigger="hover">
                            <div class="footer_code">
                                <img src="../assets/images/dy_krgy.png" alt="">
                                <p>开尔鸽业</p>
                            </div>
                            <img slot="reference" src="../assets/images/dy.png" alt="">
                        </el-popover>
                    </div>
                    <!-- <div class="item">
                        <el-popover
                            placement="top-start"
                            trigger="hover">
                            <img src="../assets/images/wx-code.png" alt="">
                            <img slot="reference" src="../assets/images/tt.png" alt="">
                        </el-popover>
                    </div> -->
                </div>
            </div>

            <!-- 移动端 -->
            <div class="flex_row felx_bottom_border media_big_hide">
                <div class="text_h1">联系我们</div>
                <div class="item"><a href="https://kaiergeye.com/" target="_blank">公棚联系方式</a></div>
            </div>

            <div class="flex_row felx_bottom_border media_big_hide">
                <div class="text_h1">相关网站</div>
                <div class="item"><a href="https://kaiergeye.com/" target="_blank">拍卖</a></div>
                <div class="item"><a href="https://kaier.cc/introduction" target="_blank">信鸽云</a></div>
                <div class="item"><a href="https://auctions.pipa.be/zh-hans/?utm_source=kaier" target="_blank">PIPA</a></div>
            </div>

            <div class="flex_row media_big_hide">
                <div class="text_h1 media_small_hide">关注我们</div>
                <div class="nav_item">
                    <div class="item">
                        <el-popover
                            placement="top-start"
                            trigger="hover">
                            <div class="footer_code">
                                <img src="../assets/images/sph_kegy.png" alt="">
                                <p>开尔鸽业</p>
                            </div>
                            <div class="footer_code">
                                <img src="../assets/images/sph_cp.png" alt="">
                                <p>开尔爱心公棚春棚</p>
                            </div>
                            <div class="footer_code">
                                <img src="../assets/images/sph_axgp.png" alt="">
                                <p>开尔爱心公棚大棚</p>
                            </div>
                            <img slot="reference" src="../assets/images/sph.png" alt="">
                        </el-popover>
                    </div>
                    <div class="item">
                        <el-popover
                            placement="top-start"
                            trigger="hover">
                            <img src="../assets/images/wx-code.png" alt="">
                            <img slot="reference" src="../assets/images/wx.png" alt="">
                        </el-popover>
                    </div>
                    <div class="item">
                        <el-popover
                            placement="top-start"
                            trigger="hover">
                            <div class="footer_code">
                                <img src="../assets/images/ks_axgp.png" alt="">
                                <p>开尔爱心公棚</p>
                            </div>
                            <div class="footer_code">
                                <img src="../assets/images/ks_kegy.png" alt="">
                                <p>开尔鸽业</p>
                            </div>
                            <img slot="reference" src="../assets/images/ks.png" alt="">
                        </el-popover>
                    </div>
                    <div class="item">
                        <el-popover
                            placement="top-start"
                            trigger="hover">
                            <div class="footer_code">
                                <img src="../assets/images/dy_krgy.png" alt="">
                                <p>开尔鸽业</p>
                            </div>
                            <img slot="reference" src="../assets/images/dy.png" alt="">
                        </el-popover>
                    </div>
                    <!-- <div class="item">
                        <el-popover
                            placement="top-start"
                            trigger="hover">
                            <img src="../assets/images/wx-code.png" alt="">
                            <img slot="reference" src="../assets/images/tt.png" alt="">
                        </el-popover>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default{
    data(){
        return{
            postData: {
                name: "",
                phoneNumber: "",
                mail: "",
                content: "",
            },
        }
    },
    computed:{
        NavList(){
            let NavList = this.$store.getters['user/NavList'] || '[]';
            const arr = JSON.parse(NavList)
            return arr;
        }
    },
    methods:{
        getIndex(){
            this.$router.push('/');
        },
        //提交意见
        getSubmit() {
            if (this.postData.phoneNumber == "") {
                this.$message.warning("联系方式不能为空！");
                return;
            } else if (this.postData.content == "") {
                this.$message.warning("留言不能为空！");
                return;
            }
            imageText.submitSuggestion(this.postData).then((res) => {
                if (res) {
                // console.log(res,'res')
                if (res.code == 1) {
                    this.$message.success("提交成功");
                    this.postData = {
                    name: "",
                    phoneNumber: "",
                    mail: "",
                    content: "",
                    };
                }
                }
            });
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/footer-common.vue